"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterStartOffer = void 0;
const request_offer_1 = __importDefault(require("@app/component/modals/request-offer"));
const util_1 = require("@app/util");
const i18n_1 = require("@app/util/i18n");
const use_modal_1 = require("@app/util/modal/use-modal");
const _ui_1 = require("@ui");
const react_1 = __importDefault(require("react"));
const FooterStartOffer = ({ details, isPluginEnabled, isTooLateToStartOffer, close, meId, hasTransfer, }) => {
    const { openModal } = (0, use_modal_1.useModal)();
    if (!details || !isPluginEnabled('offers') || meId !== details?.userId)
        return null;
    return (react_1.default.createElement("div", { style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
        } },
        react_1.default.createElement(_ui_1.Text, { type: 'body-small' },
            "DS ID: ",
            details.id),
        react_1.default.createElement("div", { style: { display: 'flex' } },
            react_1.default.createElement(_ui_1.Button, { label: (0, i18n_1.t)('CLOSE'), onClick: () => close() }),
            !hasTransfer ? (react_1.default.createElement(_ui_1.Button, { color: _ui_1.Button.COLORS.RED, label: (0, i18n_1.t)('VIEW_SHIFT_START_CONTEST'), onClickActiveWhenDisabled: true, disabled: isTooLateToStartOffer, onClick: () => {
                    if (isTooLateToStartOffer) {
                        util_1.notification.error({
                            code: 'tooLateToStartOffer',
                            message: undefined,
                        });
                    }
                    else {
                        openModal(request_offer_1.default, {
                            shiftDetail: details,
                            overSidebar: true,
                        });
                    }
                } })) : null)));
};
exports.FooterStartOffer = FooterStartOffer;
